import type { FieldType } from '@cims-online/shared'

const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  approvals: 'Approvals',
  comments: 'Comments',
  generated_int: 'Generated Integer',
  long_text: 'Long Text',
  pay_items: 'Pay Items',
  select: 'Select',
  selected_by: 'Selected By',
}

/**
 * Returns the user-facing label for a persisted workflow field type.
 */
export function fieldTypeLabel(type: FieldType) {
  return FIELD_TYPE_LABELS[type]
}
